import React from 'react';
import { Container } from 'reactstrap';

import image from "../img/NODATA.png"
import Header from '../Component/Header';
import Footer from '../Component/Footer';

// No Data Component
const NoDataFull = () => {
    return (
        <>
        <Header />
        <Container
            fluid
            className="d-flex justify-content-center align-items-center vh-100 bg-white z-50 bg-transparent"
        >
            <div className='text-center'>
            <img
                src={image}
                alt="loading"
                height={400}
                width={400}
                className="img-fluid"
                style={{ maxHeight: '600px', objectFit: 'contain' }}
            />
            <h2 className='py-4 text-blue' style={{fontWeight:"600"}}>Data Not Available</h2>
            <p className='text-secondary'>Currently, there is no data available to display. Please try again later.</p>
            </div>
        </Container>
        <Footer />
        </>
    );
};



export default NoDataFull;